export default __webpack_public_path__ + "static/char-53-125d868600207ddf7479b00e67ed260f.gif";